import { render, staticRenderFns } from "./BaseClipboardCopyInput.vue?vue&type=template&id=206d35ba"
import script from "./BaseClipboardCopyInput.vue?vue&type=script&lang=js"
export * from "./BaseClipboardCopyInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports